module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAA6ElEQVR4AWOgC/h/5EhU9d4jF57/Dw8Hko5pm4EiDCq1WBAEAFUDVcA1ANlAPfg0/P///+/fv0ASqOE/DICk5at49Vvk7XuBJJCN0ABUB0VycnA2UIWWx6SArGV2YbMCs5YB2SA9EABxNMJJK1b09u8VMGgJyFzKplbHIFPBqlrnn7EUKAKzYfp0v8IdcA3VXfuB+oEusQ6fzSBdwaBaC9RjHTZbwb4XqgGr/3j1QTawqNYB9QDJgMxlfPot+DQwKFTreE4OzFruAPaDrudkoAhCAy49fAYtQJcASSAbKILQQAwiS8OgBACrqKtg2S9TSgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/CK.png
// module id = 1110
// module chunks = 0